import { render } from "./NewsVue.vue?vue&type=template&id=3d0a30b3&scoped=true"
import script from "./NewsVue.vue?vue&type=script&lang=js"
export * from "./NewsVue.vue?vue&type=script&lang=js"

import "./NewsVue.vue?vue&type=style&index=0&id=3d0a30b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0a30b3"]])

export default __exports__